import React from 'react';
import './auth-ui.css';

interface Props {
  title?: string;
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
}

const AuthErrorBanner: React.FC<Props> = ({ title, message, onRetry, onDismiss }) => (
  <div className="auth-error" role="alert">
    <div className="auth-error-icon" aria-hidden="true">!</div>
    <div className="auth-error-body">
      {title && <p className="auth-error-title">{title}</p>}
      <p className="auth-error-message">{message}</p>
      <div className="auth-error-actions">
        {onRetry && (
          <button type="button" className="auth-error-retry" onClick={onRetry}>
            Try again
          </button>
        )}
        {onDismiss && (
          <button type="button" className="auth-error-dismiss" onClick={onDismiss}>
            Dismiss
          </button>
        )}
      </div>
    </div>
  </div>
);

export default AuthErrorBanner;
